module.exports = __webpack_public_path__ + "img/blog_icon.97589f54.svg";